import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import type { VNode } from 'vue'
import { VNodeRenderer } from '@/plugins'


export default /*@__PURE__*/_defineComponent({
  __name: 'DynamicView',
  props: {
    vNode: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.vNode)
    ? (_openBlock(), _createBlock(_unref(VNodeRenderer), {
        key: 0,
        "v-node": _ctx.vNode
      }, null, 8, ["v-node"]))
    : _createCommentVNode("", true)
}
}

})